import {PropertyBase} from "./PropertyBase";
import {ButtonGroup} from "shared/controls/ButtonGroup/ButtonGroup";
import * as React from "react";
import {ButtonGroupItem, ButtonGroupItemProps} from "shared/controls/ButtonGroup/ButtonGroupItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {ReactNode} from "react";


export class ButtonProperties extends PropertyBase{
    private buttons:ButtonOptions[]=[];
    private selectMultiple:boolean=false;
    private allowMultiple:boolean=false;



    public SetSelectMultiple(value:boolean)
    {
        this.selectMultiple=value;
    }

    protected InternalGenerationCompleted($element: JQuery) {
    }

    public AddButton(value:string,content:ReactNode,rule:string='',checkedOnMissing:boolean=false)
    {
        this.buttons.push(
            {
                Value:value,
                Content:content,
                Rule:rule,
                CheckedOnMissing:checkedOnMissing
            }
        );
        return this;
    }

    public AllowMultiple(){
        this.allowMultiple=true;
        return this;
    }

    public ElementSelected($button:JQuery,button:ButtonOptions)
    {
        //select multiple not implemented yet;
        this.$element.find('button').removeClass('active');
        $button.addClass('active');
        this.SetOptionValue(button.Value);
    }

    public SubRenderer(): React.ReactNode {
        if(this.allowMultiple)
            return this.GenerateMultipleSelectionGroup();
        else
        return(
            <div className={'rncontrol'}>
                <label>{this.label}</label>
                <ButtonGroup value={this.GetOptionValue()} onChange={e=>{this.SetOptionValue(e);this.ForceUpdate();}}>
                    {this.buttons.map(x=>
                        <ButtonGroupItem key={x.Value} Value={x.Value}>{x.Content}</ButtonGroupItem>

                    )}
                </ButtonGroup>
            </div>
        )
    }

    public Changed( values:string[])
    {

    }


    private GenerateMultipleSelectionGroup() {
        let values=[];
        for(let item of this.buttons)
        {
            let value=this.GetOptionValue(item.Rule);
            let found=value!='';

            if(item.CheckedOnMissing)
                found=!found;

            if(found)
                values.push(item.Value);
        }
        return(
            <div className={'rncontrol'}>
                <label>{this.label}</label>
                <ButtonGroup value={values} onChange={e=>{this.MultipleSelectionChanged(e);}} AllowMultiple={true}>
                    {this.buttons.map((x,i)=>
                        <ButtonGroupItem key={i} Value={x.Value}>{x.Content}</ButtonGroupItem>

                    )}
                </ButtonGroup>
            </div>
        )
    }

    private MultipleSelectionChanged(e: any[]) {
        for(let item of this.buttons)
        {
            let found=false;
            if(e.indexOf(item.Value)>=0)
                found=true;


            if(item.CheckedOnMissing)
                found=!found;
            if(found)
                this.SetOptionValue(item.Value,item.Rule);
            else
                this.SetOptionValue('',item.Rule);

        }
    }
}


interface ButtonOptions{
    Value:string;
    Content:ReactNode;
    Rule:string;
    CheckedOnMissing:boolean;
}